
// Export all notification-related functions and types
export * from './types';
export * from './db-operations';
export * from './payment-notifications';
export * from './document-notifications';
export * from './qualification-notifications';

// Import for the checkAllTeacherNotifications function
import { checkContractExpirations } from './document-notifications';
import { checkSalaryReminders } from './payment-notifications';
import { TeacherNotification } from './types';

// Check all types of notifications
export const checkAllTeacherNotifications = async (): Promise<TeacherNotification[]> => {
  const contractNotifications = await checkContractExpirations();
  const salaryNotifications = await checkSalaryReminders();
  
  return [...contractNotifications, ...salaryNotifications];
};
